import { useState } from "react";

function ReplyBox({ onReply }) {

    const [message, setMessage] = useState("");
    const [attachments, setAttachments] = useState([]);

    const submitReply = async () => {

        if (!message.trim()) return;

        const formData = new FormData();

        formData.append("message", message);

        Array.from(attachments).forEach(file => {

            formData.append("attachments", file);

        });

        await onReply(formData);

        setMessage("");
        setAttachments([]);

    };

    return (

        <div className="reply-box">

            <h3>Reply</h3>

            <textarea
                rows="5"
                value={message}
                placeholder="Type your reply..."
                onChange={(e) =>
                    setMessage(e.target.value)
                }
            />

            <input
                type="file"
                multiple
                onChange={(e) =>
                    setAttachments(e.target.files)
                }
            />

            <button onClick={submitReply}>

                Send Reply

            </button>

        </div>

    );

}

export default ReplyBox;